import React, { Component } from 'react';
import Filter from '@/components/CustomerService/Filter'
import CustomerServiceForm from '@/components/CustomerService/CustomerServiceForm'
import styled from "styled-components"
import CustomerServiceAPI from '@/API/customerService'
import OperatorAPI from '@/API/operator'
import CountryAPI from '@/API/country'
import { Table, Spin, Modal, Divider, Popconfirm, message } from 'antd'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

const Container = styled.div`
  padding: 20px;
`;

const DataTable=styled(Table)`
  margin-top:20px;
`

class CustomerService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter:{
        key:''
      },
      pagination:{
        current:1,
        pageSize:10,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      },
      loading:false,
      customerServiceList:[],
      selectedRowKeys:[],
      dialogShow:false,
      dialogType:'',
      customerService:{},
      countryList:[],
      operatorCodeList:[],
      submitLoading:false
    }
  }
  
  componentDidMount() {
    this.search()
    this.getCountry()
    this.getOperatorList()
  }
  getCountry=()=>{
    CountryAPI.getList().then((res)=>{
      this.setState({countryList:res})
    })
  }
  getOperatorList=()=>{
    OperatorAPI.getOperatorCodeList().then((res)=>{
      if(!res.code){
        let obj=res.length?res:[]
        obj.unshift('/')
        this.setState({operatorCodeList:obj})
      }
    })
  }
  filterChange=(key,value)=>{
    let field={}
    field[key]=value
    this.setState(prevState=>({
      filter:{
        ...prevState.filter,
        ...field
      }
    }))
  }
  handleTableChange=(pagination)=>{
    this.setState({
      pagination: pagination,
    },()=>{
      this.getData()
    });
  }
  deleteCustomerService=(ids)=>{
    CustomerServiceAPI.del(ids).then((res)=>{
      if(!res.code){
        message.success(this.props.t('Deleted successfully.'))
      }
      this.getData()
    })
  }
  addCustomerService=()=>{
    this.setState({submitLoading:true})
    CustomerServiceAPI.add(this.state.customerService).then((res)=>{
      if(!res.code){
        this.setState({dialogShow:false,submitLoading:false})
        message.success(this.props.t('Added successfully.'))
        this.getData()
      }
    }).catch(()=>{
      this.setState({submitLoading:false})
    })
  }
  editCustomerService=()=>{
    this.setState({submitLoading:true})
    CustomerServiceAPI.edit(this.state.customerService).then((res)=>{
      if(!res.code){
        this.setState({dialogShow:false,submitLoading:false})
        message.success(this.props.t('Edited successfully.'))
        this.getData()
      }
    }).catch(()=>{
      this.setState({submitLoading:false})
    })
  }
  add=()=>{
    this.setState({
      dialogShow:true,
      dialogType:'add',
      customerService:{}
    })
  }
  del=()=>{
    if(this.state.selectedRowKeys&&this.state.selectedRowKeys.length){
      this.deleteCustomerService(this.state.selectedRowKeys)
    }
  }
  exp=()=>{
    CustomerServiceAPI.exp().then((res)=>{
      if(!res.code){
        message.success(res.info)
      }
    })
  }
  initEdit=(record)=>{
    this.setState({
      dialogShow:true,
      dialogType:'edit',
      customerService:record
    })
  }
  search=()=>{
    this.setState((prevState)=>({
      pagination:{
        ...prevState.pagination,
        current:1
      }
    }),()=>{
      this.getData()
    })
  }
  getData=()=>{
    this.setState({loading:true})
    const {pagination}=this.state
    CustomerServiceAPI.getList({
      key:this.state.filter.key,
      pageIndex:pagination.current-1,
      pageSize:pagination.pageSize
    }).then((res)=>{
      this.setState((prevState)=>({
        loading:false,
        customerServiceList:res.datas,
        pagination:{
          ...prevState.pagination,
          total:res.totalCount
        }
      }))
    }).catch(()=>{
      this.setState({loading:false})
    })
  }
  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys })
  }
  validate=()=>{
    // const fields=['name','countryCode','operator','phoneNumber'];
    const fields=['name','operator','phoneNumber'];
    const messages={
      name:this.props.t('Enter a name.'),
      // countryCode:this.props.t('Select a country or region.'),
      operator:this.props.t('Select a carrier code.'),
      phoneNumber:this.props.t('Enter a phone number.')
    }
    for(let i=0;i<fields.length;i++){
      if(!this.state.customerService[fields[i]]){
        message.error(messages[fields[i]])
        return false
      }
    }
    return true
  }
  handleOk=()=>{
    if(this.validate()){
      if(this.state.dialogType==='add'){
        this.addCustomerService()
      }else{
        this.editCustomerService()
      }
    }
  }
  handleCancel=()=>{
    this.setState({dialogShow:false})
  }
  fieldChange=(key,value)=>{
    let field={}
    field[key]=value
    this.setState(prevState=>({
      ...prevState,
      customerService:{
        ...prevState.customerService,
        ...field
      }
    }))
  }
  render() {
    const {loading,customerServiceList,pagination,selectedRowKeys,dialogShow,dialogType,countryList,operatorCodeList,customerService,submitLoading}=this.state
    const {t,roleId}=this.props
    const columns=[
      {
        title:t('Name'),
        dataIndex:'name'
      },
      // {
      //   title:t('Country/Region'),
      //   dataIndex:'countryName',
      //   render:(text,record)=>(`${record.countryName}(${record.countryCode})`)
      // },
      {
        title:t('Carrier Code'),
        dataIndex:'operator'
      },
      {
        title:t('Phone Number'),
        dataIndex:'phoneNumber'
      },
      {
        title:t('Link'),
        key:'link',
        align:'center',
        render:(text,record)=>(
          <span>
            <a href={record.link}>{record.link}</a>
          </span>
        )
      },
      {
        title:t('APK White List'),
        dataIndex:'apkWhiteList'
      },
      {
        title:t('Operation'),
        key:'action',
        align:'center',
        render:(text,record)=>(
          <span>
            <a onClick={()=>this.initEdit(record)}>{t('Edit')}</a>
            <Divider type="vertical" />
            {
              (roleId==1||roleId==2)&&(
                <Popconfirm title={t("Delete the selected customer service contact numbers?")} okType="danger" onConfirm={()=>this.deleteCustomerService([record.id])}>
                  <a>{t('Delete')}</a>
                </Popconfirm>
              )
            }
          </span>
        )
      }
    ]
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    }
    return (
      <Container>
        <Filter roleId={roleId} filterChange={this.filterChange} search={this.search} add={this.add} del={this.del} exp={this.exp}></Filter>
        {/* {roleId==3?null:(<Filter roleId={roleId} filterChange={this.filterChange} search={this.search} add={this.add} del={this.del} exp={this.exp}></Filter>)} */}

        <Spin spinning={loading}>
          {/* <DataTable rowSelection={roleId==3?null:rowSelection} columns={columns} dataSource={customerServiceList} rowKey="id" pagination={pagination} onChange={this.handleTableChange}></DataTable> */}
          <DataTable rowSelection={rowSelection} columns={columns} dataSource={customerServiceList} rowKey="id" pagination={pagination} onChange={this.handleTableChange}></DataTable>
        </Spin>
        {
          dialogShow&&(
            <Modal maskClosable={false} title={dialogType==='add'?t('Add Customer Service'):t('Edit Customer Service')} visible={dialogShow} onOk={this.handleOk} onCancel={this.handleCancel} confirmLoading={submitLoading}>
              <CustomerServiceForm customerService={customerService} countryList={countryList} operatorCodeList={operatorCodeList} fieldChange={this.fieldChange}></CustomerServiceForm>
            </Modal>
          )
        }
      </Container>
    );
  }
}

const mapStateToProps = (state)=>{
  return {
    roleId:state.roleId,
    operator:state.operator
  }
}

export default connect(mapStateToProps)(withTranslation()(CustomerService));